export type Language = 'ko' | 'jp' | 'en'

export const languageBasedOnTimezone = (): Language => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  switch (timeZone) {
    case 'Asia/Seoul':
      return 'ko'
    case 'Asia/Tokyo':
      return 'jp'
    default:
      return 'en'
  }
}
